/**
 * Public site announcements context. Provider lives in PublicSiteAnnouncementsProvider.tsx.
 */

import {
  createContext,
  use,
} from 'react';

import type { SiteAnnouncement } from '@lambda/shared/types';

export interface PublicSiteAnnouncementsValue {
  announcements: SiteAnnouncement[];
  loading: boolean;
  dismiss: (announcementId: string) => void;
  refetch: () => Promise<void>;
}

const defaultValue: PublicSiteAnnouncementsValue = {
  announcements: [],
  loading: true,
  dismiss: () => {},
  refetch: async () => {},
};

export const PublicSiteAnnouncementsContext = createContext<PublicSiteAnnouncementsValue>(defaultValue);

export function usePublicSiteAnnouncements(): PublicSiteAnnouncementsValue {
  return use(PublicSiteAnnouncementsContext);
}
